/**
 * 토큰 카운팅 — 결정 #12. 정확한 토크나이저(tiktoken WASM)는 6s+ 보호를 위해
 * lazy-load 대상이므로, core에는 의존성 없는 휴리스틱만 둔다. 프로바이더
 * 어댑터가 더 정확한 카운터를 주입할 수 있도록 함수 타입으로 추상화한다.
 */

/** 텍스트의 대략적 토큰 수를 반환하는 함수(주입 가능). */
export type TokenCounter = (text: string) => number;

/**
 * 의존성 없는 휴리스틱 토큰 카운터. 영문 ~4자/토큰, CJK는 글자당 비용이 높아
 * 가중치를 둔다. 예산 할당(트림)에는 충분히 안전한 근사치다.
 */
export const heuristicTokenCount: TokenCounter = (text: string): number => {
  if (!text) return 0;
  let cjk = 0;
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i);
    // CJK 통합 한자 / 한글 음절 / 일본어 가나 대략 범위.
    if (
      (code >= 0x3040 && code <= 0x30ff) ||
      (code >= 0x3400 && code <= 0x9fff) ||
      (code >= 0xac00 && code <= 0xd7a3)
    ) {
      cjk++;
    }
  }
  const ascii = text.length - cjk;
  // ASCII ~4자/토큰, CJK ~1.5자/토큰.
  return Math.ceil(ascii / 4 + cjk / 1.5);
};
